import { BookAIcon, ClipboardListIcon, GrapeIcon, ListChecksIcon, UtensilsIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Schede di Degustazione Guidate',
    description: 'Schede da compilare a ogni assaggio per bianchi, rosati, rossi, spumanti e vini dolci.',
    icon: ClipboardListIcon,
  },
  {
    number: '2',
    title: 'Atlante dei Vitigni Italiani e Internazionali',
    description: 'Una scheda per vitigno con zone, profumi, stili e abbinamenti tipici.',
    icon: GrapeIcon,
  },
  {
    number: '3',
    title: 'Carte di Abbinamento Cibo-Vino',
    description: 'Carte rapide per antipasti, primi, secondi, formaggi, dessert e cucine del mondo.',
    icon: UtensilsIcon,
  },
  {
    number: '4',
    title: 'Glossario del Vino',
    description: 'I termini di vigna, cantina, degustazione ed etichetta spiegati in modo semplice.',
    icon: BookAIcon,
  },
  {
    number: '5',
    title: '300 Domande di Ripasso con Risposte',
    description: 'Domande divise per volume, con risposte spiegate, per verificare la tua preparazione.',
    icon: ListChecksIcon,
  },
];
